import { Grid } from "@material-ui/core";
import React from "react";
import { useStyles } from "./classes";

export default function DummyPage() {
  const classes = useStyles();

  return (
    <Grid
      className={classes.marginTop}
      container
      direction="row"
      justify="center"
      alignItems="center"
    >
      <Grid item xs={8}>
        <h1 className={classes.header}>Corona Virus Updates</h1>

        <p className={classes.para}>Dear Users and Customers,</p>
        <p className={classes.para}>
          As coronavirus <strong>(COVID-19)</strong> continues to impact the
          global community, we want to update you on the steps we have taken to
          ensure business continuity for our users and customers.
        </p>
        <p className={classes.para}>
          Based on guidance from the World Health Organization, we have updated
          our Business Continuity Plan with specific steps to account for{" "}
          <strong>COVID-19.</strong>
        </p>
        <p className={classes.para}>
          GottaMenu, LLC encourages every individual and business to respect the
          health and safety standards of anyone and any location at all times.{" "}
        </p>
        <p className={classes.para}>
          It goes without saying that, in the current environment, the health
          and safety of our employees, users, customers, and partners are
          priority. This is an unprecedented time for everyone, and the
          situation is changing daily. We are committed to maintaining our
          business operations and ensuring you continue to receive the highest
          quality service without disruption.
        </p>
        <p className={classes.para}>
          Thank you for your continued trust in{" "}
          <span className={classes.spanText}>GottaMenu</span>, LLC.
        </p>
      </Grid>
    </Grid >
  );
}
